import { makeStyles, tokens } from '@fluentui/react-components';

export const useGroupSearchStyles = makeStyles({
  pickerCard: {
    display: 'flex',
    alignItems: 'stretch',
    borderTopWidth: '1px',
    borderRightWidth: '1px',
    borderBottomWidth: '1px',
    borderLeftWidth: '1px',
    borderTopStyle: 'solid',
    borderRightStyle: 'solid',
    borderBottomStyle: 'solid',
    borderLeftStyle: 'solid',
    borderTopColor: tokens.colorNeutralStroke1,
    borderRightColor: tokens.colorNeutralStroke1,
    borderBottomColor: tokens.colorNeutralStroke1,
    borderLeftColor: tokens.colorNeutralStroke1,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground1,
    overflow: 'hidden',
  },

  providerButton: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    borderRight: 'none',
    borderTop: 'none',
    borderBottom: 'none',
    borderLeftWidth: '0px',
    borderRightWidth: '1px',
    borderRightStyle: 'solid',
    borderRightColor: tokens.colorNeutralStroke1,
    backgroundColor: tokens.colorNeutralBackground2,
    cursor: 'pointer',
    flexShrink: '0',
    minWidth: '120px',
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase300,
    fontFamily: tokens.fontFamilyBase,
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground3,
    },
    ':disabled': {
      opacity: '0.5',
      cursor: 'not-allowed',
    },
  },

  providerLabel: {
    flex: '1',
    whiteSpace: 'nowrap',
    textAlign: 'left',
  },

  inputSide: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    paddingLeft: tokens.spacingHorizontalS,
    paddingRight: tokens.spacingHorizontalS,
    paddingTop: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalXS,
    minWidth: '0',
    justifyContent: 'center',
  },

  combobox: {
    width: '100%',
    border: 'none',
    boxShadow: 'none',
    backgroundColor: 'transparent',
    '&:focus-within': {
      border: 'none',
      boxShadow: 'none',
    },
  },

  groupIdHint: {
    fontSize: tokens.fontSizeBase100,
    color: tokens.colorNeutralForeground3,
    fontFamily: tokens.fontFamilyMonospace,
    paddingLeft: tokens.spacingHorizontalXS,
    marginTop: tokens.spacingVerticalXXS,
    minHeight: tokens.lineHeightBase200,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  appInput: {
    width: '100%',
    border: 'none',
    boxShadow: 'none',
    backgroundColor: 'transparent',
    '&:focus-within': {
      border: 'none',
      boxShadow: 'none',
    },
  },

  addButton: {
    flexShrink: '0',
    alignSelf: 'center',
    marginRight: tokens.spacingHorizontalS,
  },

  errorText: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorPaletteRedForeground1,
    paddingTop: tokens.spacingVerticalXXS,
  },
});
